import { render } from "./RetailForm.vue?vue&type=template&id=75ca8f3a"
import script from "./RetailForm.vue?vue&type=script&lang=js"
export * from "./RetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QSplitter,QBtn,QTree,QTabPanels,QTabPanel});
